// extracted by mini-css-extract-plugin
export default {"authContainer":"index_authContainer__irgTb","dialogRoot":"index_dialogRoot__SrL+f"};